export const aboutComparisonDe = {
  'about.problem.requires': 'Erfordert:',
  'about.problem.onlyfans.body': 'Ein Creator mit 10.000 $/Monat verliert 24.000 $ pro Jahr an Gebühren.',
  'about.problem.onlyfans.requires': 'Bankkonto + KYC',
  'about.problem.throne.body': 'Plus Währungsumrechnung. Plus Auszahlungsverzögerungen. Auf 10 Länder beschränkt.',
  'about.problem.throne.requires': 'Bankkonto + KYC',
  'about.problem.linktree.body': 'Oder zahle 40 $/Monat für 0 % Gebühren. So oder so nehmen sie dein Geld.',
  'about.problem.linktree.requires': 'Bankkonto + Zahlungsdienstleister',
  'about.problem.kickstarter.body': 'Plus 5.000-25.000 $ Fulfillment-Kosten. Alles-oder-nichts-Finanzierung.',
  'about.problem.kickstarter.requires': 'Bankkonto + KYC + Fulfillment',
  'about.problem.indiegogo.body': '5 % Einbehaltung bis zur Lieferung. 14-tägige Auszahlungsverzögerungen. Flexibel, aber teuer.',
  'about.problem.indiegogo.requires': 'Bankkonto + KYC + Fulfillment',
  'about.problem.katoa.body': 'Keine Gebühren. Keine Verzögerungen. Behalte 100 % bis zum 31. Dezember 2026.',
  'about.problem.katoa.requires': 'Kein Bankkonto nötig. Kein KYC.',
  'about.problem.avgLoss': 'Durchschnittlicher Creator verliert',
  'about.problem.avgLossAmount': '12.000-24.000 $/Jahr',
  'about.problem.allRequire': 'Alle 5 Plattformen erfordern:',
  'about.problem.bankAccount': 'Bankkonto',
  'about.problem.kyc': 'KYC-Verifizierung',
  'about.problem.processors': 'Zahlungsdienstleister',
  'about.problem.geoLimits': 'Geografische Beschränkungen',
  'about.problem.katoaRequires': 'KATOA erfordert: NICHTS',
  'about.problem.katoaWallet': 'Nur eine Bitcoin-Lightning-Wallet. Das war\'s.',
  'about.solution.title': 'Unsere Lösung: Bitcoin + Dezentralisierung',
  'about.solution.subtitle': 'Wir haben KATOA auf Technologie aufgebaut, die Plattformgebühren unmöglich macht.',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'Bitcoins Lightning Network ermöglicht schnelle, günstige Transaktionen weltweit, sobald der Lightning-Empfang live ist (Roadmap: in Arbeit). Kein Zahlungsdienstleister, der mitnimmt. Keine 7-Tage-Verzögerungen. Keine geografischen Beschränkungen.',
  'about.solution.lightning.item1': 'Abwicklung in unter 1 Sekunde',
  'about.solution.lightning.item2': 'Funktioniert in über 195 Ländern',
  'about.solution.lightning.item3': 'Mikrozahlungen bis zu Satoshis',
  'about.solution.lightning.item4': 'Kein Bankkonto erforderlich',
  'about.solution.nostr.title': 'Nostr-Protokoll',
  'about.solution.nostr.body': 'Ein dezentrales soziales Protokoll, das Zensur unmöglich macht. Dein Konto, deine Daten, deine Regeln. Kein Unternehmen kann dich sperren oder deine Daten ausbeuten.',
  'about.solution.nostr.item1': 'Keine Kontosperrungen (du besitzt deine Schlüssel)',
  'about.solution.nostr.item2': 'Optionale verschlüsselte Nachrichten (NIP-17)',
  'about.solution.nostr.item3': 'Zero-Knowledge-Zahlungsnachweise (Roadmap)',
  'about.solution.nostr.item4': 'Verteilt über Relays weltweit',
  'about.solution.result.title': 'Das Ergebnis: 0 % Gebühren bis zum 31. Dezember 2026',
  'about.solution.result.body': 'Wenn Zahlungen peer-to-peer über Bitcoin fließen, gibt es keinen Zwischenhändler, der Gebühren nimmt. Das ist kein Aktionspreis. So funktioniert die Technologie.',
  'about.values.title': 'Wofür wir stehen',
  'about.values.creators.title': 'Creator zuerst',
  'about.values.creators.desc': 'Jede Entscheidung priorisiert Creator-Einnahmen und Freiheit.',
  'about.values.privacy.title': 'Privatsphäre immer',
  'about.values.privacy.desc': 'Minimale Datenerhebung. Zahlungen gehen in deine Wallet. Deine Schlüssel bleiben deine.',
  'about.values.global.title': 'Wirklich global',
  'about.values.global.desc': 'Keine geografische Diskriminierung. Bitcoin funktioniert überall, für alle.',
  'about.values.censorship.title': 'Zensurresistent',
  'about.values.censorship.desc': 'Dezentral by Design. Kein Unternehmen kann dich sperren oder deine Inhalte kontrollieren.',
  'about.competitors.title': 'Warum jeder Konkurrent scheitert',
  'about.competitors.subtitle': 'Sie alle haben denselben Grundfehler: Abhängigkeit von traditionellen Banksystemen.',
  'about.competitors.onlyfans.title': 'OnlyFans: 20 % Plattformsteuer',
  'about.competitors.onlyfans.body': 'Ein Creator mit 10.000 $/Monat verliert 2.000 $ pro Monat (24.000 $/Jahr). Plus Zensurrisiko durch Mastercard/Visa. Plus Sperrungen ohne Einspruch.',
  'about.competitors.kickstarter.title': 'Kickstarter: Fulfillment-Albtraum',
  'about.competitors.kickstarter.body': '5 % Plattform plus Zahlungsabwicklung (typisch ~8–10 % insgesamt), plus 5.000–25.000 $+ Fulfillment. Ziel verfehlt = 0 $.',
  'about.competitors.indiegogo.title': 'Indiegogo: Versteckte Einbehaltungen',
  'about.competitors.indiegogo.body': '8-15 % Gesamtgebühren, inkl. 5 % Einbehaltung bis zur Lieferung. Flexibles Funding klingt gut, bis sie dein Geld festhalten.',
  'about.competitors.linktree.title': 'Linktree: Pay-to-Win-Monetarisierung',
  'about.competitors.linktree.body': 'Gratis-Tarif: 10 % Gebühren. Oder 40 $/Monat (480 $/Jahr) für 0 %. So oder so verlierst du Geld nur für eine Landingpage.',
  'about.competitors.throne.title': 'Throne: die 0-%-Rechnung',
  'about.competitors.throne.body': 'Wirbt mit „0 % Gebühren“; typisch sind ~10 % insgesamt. Echtes 0 % nur in ~10 Ländern — sonst zahlst du den Rest.',
  'about.competitors.con.bankKyc': 'Erfordert Bankkonto + KYC',
  'about.competitors.con.payout7': '7-tägige Auszahlungsverzögerungen',
  'about.competitors.con.payout14': '14+ Tage Auszahlungsverzögerungen',
  'about.competitors.con.censorship': 'Zensur durch Zahlungsdienstleister',
  'about.competitors.con.countries': 'Auf unterstützte Länder beschränkt',
  'about.competitors.con.fulfillment': 'Versand/Fulfillment-Stress',
  'about.competitors.con.oneTime': 'Nur einmalige Finanzierung',
  'about.competitors.con.holdback': '5 % bis Produktlieferung einbehalten',
  'about.competitors.con.fulfillmentReq': 'Fulfillment erforderlich',
  'about.competitors.con.processor': 'Erfordert Zahlungsdienstleister',
  'about.competitors.con.geoRestrict': 'Geografische Beschränkungen',
  'about.competitors.con.feesOrSub': '9-10 % Gebühren oder 480 $/Jahr',
  'about.competitors.con.countries50': 'Auf 50 Länder beschränkt',
  'about.competitors.con.withdraw7': '7-tägige Abhebungsverzögerungen',
  'about.competitors.con.countries10': 'Auf 10 Länder für 0 % beschränkt',
  'about.competitors.con.conversion': 'Versteckte Währungsumrechnungsgebühren',
  'about.competitors.katoa.title': 'KATOA: Die einzige echte Alternative',
  'about.competitors.katoa.body': 'Lightning-Routing/Netzgebühren zahlen die Unterstützer. Wir veröffentlichen jede Änderung, bevor dieser Zeitraum endet.',
  'about.competitors.katoa.fee': '0 % Plattformgebühr bis zum 31. Dezember 2026',
  'about.competitors.katoa.feeDesc': 'Getragen von Give A Bit und der Community',
  'about.competitors.katoa.payout': 'Schnelle Auszahlungen (Roadmap)',
  'about.competitors.katoa.payoutDesc': 'Über Lightning — sobald der Empfang verfügbar ist (Roadmap: in Arbeit).',
  'about.competitors.katoa.bank': '✓ Keine Bank nötig',
  'about.competitors.katoa.bankDesc': 'Nur eine Lightning-Wallet.',
  'about.competitors.katoa.global': '✓ Über 195 Länder',
  'about.competitors.katoa.globalDesc': 'Funktioniert überall gleich.',
  'about.audience.title': 'Wen wir bedienen',
  'about.audience.subtitle': 'KATOA wurde für Creator gebaut, die traditionelle Plattformen ignorieren.',
  'about.audience.unbanked.title': 'Die Unbanked',
  'about.audience.unbanked.body': 'Creator in Argentinien, Nigeria, Venezuela, Vietnam. Länder, in denen Stripe und PayPal nicht funktionieren.',
  'about.audience.unbanked.stat': 'Über 195 Länder unterstützt',
  'about.audience.privacy.title': 'Die Privatsphäre-Bewussten',
  'about.audience.privacy.body': 'Creator, die Überwachung ablehnen. Die Ende-zu-Ende-Verschlüsselung wollen. Die Datensouveränität fordern.',
  'about.audience.privacy.stat': 'Minimale Daten, nicht verwahrend',
  'about.audience.ambitious.title': 'Die Ehrgeizigen',
  'about.audience.ambitious.body': 'Creator mit 10.000-100.000 $+ pro Monat, die es satt haben, 10-20 % an Gebühren zu verlieren.',
  'about.audience.ambitious.stat': 'Spare 12.000-240.000 $ jährlich',
  'about.team.title': 'Von Creatorn für Creator',
  'about.team.body1': 'Wir sind ein Team von Creatorn, die es satt hatten, 10-20 % unserer Einnahmen an Plattformen zu verlieren. Also haben wir etwas Besseres gebaut.',
  'about.team.body2': 'Wir sind nicht venture-finanziert. Wir antworten nicht Investoren, die Wachstum um jeden Preis fordern. Wir antworten Creatorn. Deshalb werden wir nie Gebühren erheben.',
  'about.team.promise': 'Unser Versprechen',
  'about.team.promise1': 'Wir werden nie Plattformgebühren erheben',
  'about.team.promise2': 'Wir werden nie deine Daten ausbeuten',
  'about.team.promise3': 'Wir werden nie Creator für legale Inhalte sperren',
  'about.team.promise4': 'Wir werden immer deine Einnahmen vor unsere stellen',
  'about.cta.title': 'Schließe dich der Bewegung an',
  'about.cta.subtitle': 'Noch am Anfang. Mach mit und behalte 100 % — 0 % Plattformgebühr bis zum 31. Dezember 2026.',
  'about.cta.highlight': 'Sei der Nächste.',
  'about.cta.start': 'Starte mit 100 % Verdienst',
  'about.cta.compare': 'Sieh die Zahlen',
  'about.cta.footer': 'Keine Gebühren. Kein KYC. Keine Tricks. Nur du behältst 100 %.',
  'comparison.badge': 'Ehrlicher Vergleich • Kein Marketing',
  'comparison.earningsLabel': 'Deine monatlichen Einnahmen (USD)',
  'comparison.savingsYearly': 'Basierend auf ${amount}/Monat — das sind ${yearly}/Jahr zurück in deiner Tasche.',
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': 'Im Rechner anpassen ↓',
  'comparison.breakdown.title': 'Funktion-für-Funktion-Vergleich',
  'comparison.table.feature': 'Funktion',
  'comparison.table.swipe': 'Wischen für mehr',
  'comparison.card.countries.title': 'Über 195 Länder',
  'comparison.card.countries.body': 'Kein Bankkonto? Kein Problem. Bitcoin funktioniert überall, für alle. Keine Diskriminierung.',
  'comparison.card.countries.throne': 'Throne: ~10 Länder mit 0 % Gebühren',
  'comparison.card.countries.katoa': 'KATOA: Alle Länder, 0 % bis zum 31. Dez. 2026',
  'comparison.card.privacy.title': 'Echte Privatsphäre',
  'comparison.card.privacy.body': 'Minimale Datenerhebung. Nicht verwahrend. Verschlüsselte Nachrichten sind optional (NIP-17). ZK-Proofs stehen auf der Roadmap.',
  'comparison.card.privacy.others': 'Andere: Deine Daten sind ihr Produkt',
  'comparison.card.privacy.katoa': 'KATOA: nicht verwahrend, minimale Daten',
  'comparison.card.instant.title': 'Schnelle Abwicklung (Roadmap)',
  'comparison.card.instant.body': 'Behalte 100 % deiner Einnahmen. Skaliere global. Baue dein Imperium ohne Plattformsteuern.',
  'comparison.card.instant.others': 'Andere: 7-14 Tage auf Auszahlungen warten',
  'comparison.card.instant.katoa': 'KATOA: Sofortiges Lightning Network (mit Lightning-Empfang — siehe Roadmap)',
  'comparison.cta.title': 'Bereit, 100 % zu behalten?',
  'comparison.cta.subtitle': 'Früh dabei sein. 0 % Plattformgebühr. Behalte, was Unterstützer senden — Lightning-Netzwerkgebühren fallen trotzdem an.',
  'comparison.cta.start': 'Starte mit 100 % Verdienst',
  'comparison.cta.pricing': 'Preise ansehen (Spoiler: 0 $)',
  'comparison.cat.fees': 'Gebühren & Kosten',
  'comparison.cat.banking': 'Bankanforderungen',
  'comparison.cat.global': 'Globale Reichweite',
  'comparison.cat.payout': 'Auszahlungsgeschwindigkeit',
  'comparison.cat.revenue': 'Einnahmemodelle',
  'comparison.cat.privacy': 'Privatsphäre & Sicherheit',
  'comparison.cat.payment': 'Zahlungsfunktionen',
  'comparison.cat.control': 'Plattformkontrolle',
  'comparison.feat.platformFees': 'Plattformgebühren',
  'comparison.feat.paymentProcessing': 'Zahlungsabwicklung',
  'comparison.feat.totalFee10k': 'Gesamtgebühr bei 10.000 $',
  'comparison.feat.monthlySub': 'Monatliches Abo',
  'comparison.feat.withdrawalFees': 'Abhebungsgebühren',
  'comparison.feat.hiddenCosts': 'Versteckte Kosten',
  'comparison.feat.bankRequired': 'Bankkonto erforderlich',
  'comparison.feat.kyc': 'KYC/Identitätsprüfung',
  'comparison.feat.noBanking': 'Funktioniert ohne Bank',
  'comparison.feat.processorDep': 'Abhängig vom Zahlungsdienstleister',
  'comparison.feat.countries': 'Unterstützte Länder',
  'comparison.feat.sanctioned': 'Bitcoin ist global',
  'comparison.feat.instantIntl': 'Schnelle internationale Überweisungen (Roadmap)',
  'comparison.feat.conversion': 'Währungsumrechnungsgebühren',
  'comparison.feat.payoutTime': 'Auszahlungszeit',
  'comparison.feat.instantSettlement': 'Schnelle Abwicklung (Roadmap)',
  'comparison.feat.holdback': 'Geldeinbehaltung',
  'comparison.feat.crowdfunding': 'Crowdfunding/Projekte',
  'comparison.feat.subscriptions': 'Abonnements (Demo)',
  'comparison.feat.tips': 'Trinkgelder/Spenden',
  'comparison.feat.digital': 'Digitale Produkte',
  'comparison.feat.fulfillment': 'Fulfillment erforderlich',
  'comparison.feat.zk': 'Zero-Knowledge-Proofs (Roadmap)',
  'comparison.feat.encrypted': 'Verschlüsselte Nachrichten (NIP-17 optional)',
  'comparison.feat.decentralized': 'Dezentrale Infrastruktur',
  'comparison.feat.censorship': 'Zensurresistent',
  'comparison.feat.micro': 'Mikrozahlungs-Support',
  'comparison.feat.bolt12': 'BOLT 12 wiederkehrend (geplant)',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': 'Mehrere Einnahmequellen',
  'comparison.feat.suspension': 'Risiko der Kontosperrung',
  'comparison.feat.contentCensor': 'Inhaltszensur',
  'comparison.feat.ownData': 'Besitze deine Daten',
  'comparison.feat.ownKeys': 'Besitze deine Schlüssel',

  'comparison.cell.instant': 'Schnell',
  'comparison.cell.none': 'Keine',
  'comparison.cell.varies': 'Variiert',
  'comparison.cell.included': 'Enthalten',
  'comparison.cell.limited': 'Begrenzt',
  'comparison.cell.demo': 'Demo',
  'comparison.cell.planned': 'Geplant',
  'comparison.cell.roadmap': 'Roadmap',

  'comparison.metaTitle': 'Plattformvergleich',
  'comparison.metaDesc': 'Vergleiche KATOA mit OnlyFans, Throne, Kickstarter und mehr. 0 % Plattformgebühr, Lightning-Abrechnung, kein KYC zum Start.',
} as const;